import {
  FEE_ENTITY_TYPES,
  PERMISSION_ACTION_ADD,
  PERMISSION_ACTION_ACCEPT,
  PERMISSION_ACTION_APPROVE,
  PERMISSION_ACTION_COMPLETE,
  PERMISSION_ACTION_DELETE,
  PERMISSION_ACTION_DENY,
  PERMISSION_ACTION_EDIT,
  PERMISSION_ACTION_FUND,
  PERMISSION_ACTION_PUBLISH,
  PERMISSION_ACTION_REJECT,
  PERMISSION_ACTION_VOID,
  PERMISSION_ACTION_VIEW,
  PERMISSION_ENTITY_EXTERNAL_BUFFER_FEE,
  PERMISSION_ENTITY_INVOICE,
  PERMISSION_ENTITY_INVOICE_OFFER,
  PERMISSION_ENTITY_LATE_FEE,
  PERMISSION_ENTITY_OPERATIONAL,
  PERMISSION_ENTITY_PAAS_OFFER,
  PERMISSION_ENTITY_PAYMENT,
  PERMISSION_ENTITY_PLATFORM_FEE,
  PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
  PERMISSION_ENTITY_PURCHASE_ORDER,
  ORDER_EVENT_ACTIONS
} from '@klear/constants'

export const ORDER_EVENT_DOCUMENT_LIST_MAX_IDS = 100
export const ORDER_EVENT_DOCUMENT_LIST_PAGE_SIZE = 1000

export const ORDER_EVENT_UPDATE_TYPES = [
  PERMISSION_ACTION_ADD,
  PERMISSION_ACTION_EDIT,
  PERMISSION_ACTION_DELETE,
  ...ORDER_EVENT_ACTIONS
] as const

export type OrderEventUpdateType = (typeof ORDER_EVENT_UPDATE_TYPES)[number]

export const ORDER_EVENT_ACTION_BULK_TYPES = [
  PERMISSION_ACTION_PUBLISH,
  PERMISSION_ACTION_VOID,
  PERMISSION_ACTION_ACCEPT,
  PERMISSION_ACTION_REJECT,
  PERMISSION_ACTION_APPROVE,
  PERMISSION_ACTION_DENY,
  PERMISSION_ACTION_FUND,
  PERMISSION_ACTION_COMPLETE
] as const

export type OrderEventActionBulkEnum = (typeof ORDER_EVENT_ACTION_BULK_TYPES)[number]

export const ORDER_EVENT_ACTION_CRUD_TYPES = [
  PERMISSION_ACTION_VIEW,
  PERMISSION_ACTION_ADD,
  PERMISSION_ACTION_EDIT,
  PERMISSION_ACTION_DELETE
] as const

export type OrderEventActionCrudEnum = (typeof ORDER_EVENT_ACTION_CRUD_TYPES)[number]

export type OrderEventActionEnum = OrderEventActionBulkEnum | OrderEventActionCrudEnum

export const ORDER_EVENT_INTERNAL_NOTE_FIELDS = [
  'document',
  'number',
  'amount',
  'effectiveDate',
  'endDate',
  'incoterm',
  'customer'
] as const

export type OrderEventInternalNoteField = (typeof ORDER_EVENT_INTERNAL_NOTE_FIELDS)[number]

export const INTERNAL_NOTE_FIELDS_BY_EVENT_TYPE: Partial<Record<string, readonly OrderEventInternalNoteField[]>> = {
  [PERMISSION_ENTITY_PURCHASE_ORDER]: [
    'document',
    'customer',
    'number',
    'amount',
    'effectiveDate',
    'endDate',
    'incoterm'
  ],
  [PERMISSION_ENTITY_INVOICE]: ['document', 'customer', 'number', 'amount', 'effectiveDate', 'endDate'],
  [PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE]: ['document', 'customer', 'effectiveDate']
}

export const ORDER_EVENT_OPERATIONAL_TITLES = [
  'Manufacturing',
  'Shipping',
  'Last Mile',
  'Clearance',
  'Purchase Material',
  'Cut Material',
  'Form Material',
  'Sub-Assembly',
  'Paint',
  'Final-Assembly',
  'Custom Modification Assembly',
  'Palletize/Crate',
  'Bag Material',
  'Kit/Crate'
] as const

export const ORDER_EVENT_ORDER_EVENT_TYPES = [
  PERMISSION_ENTITY_PURCHASE_ORDER,
  PERMISSION_ENTITY_INVOICE,
  PERMISSION_ENTITY_OPERATIONAL,
  PERMISSION_ENTITY_INVOICE_OFFER,
  PERMISSION_ENTITY_PAAS_OFFER,
  PERMISSION_ENTITY_PAYMENT,
  PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
  PERMISSION_ENTITY_PLATFORM_FEE,
  PERMISSION_ENTITY_EXTERNAL_BUFFER_FEE,
  PERMISSION_ENTITY_LATE_FEE
] as const

export type OrderEventOrderEventType = (typeof ORDER_EVENT_ORDER_EVENT_TYPES)[number]

export type OrderEventType = OrderEventOrderEventType | OrderEventActionEnum

export const ORDER_EVENT_LIST_FILTER_TYPES = [
  PERMISSION_ENTITY_PURCHASE_ORDER,
  PERMISSION_ENTITY_INVOICE,
  PERMISSION_ENTITY_OPERATIONAL,
  PERMISSION_ENTITY_PROOF_OF_ACCEPTANCE,
  PERMISSION_ENTITY_INVOICE_OFFER,
  PERMISSION_ENTITY_PAYMENT,
  ...FEE_ENTITY_TYPES
] as const

export type OrderEventListFilterType = (typeof ORDER_EVENT_LIST_FILTER_TYPES)[number]
